<div
  class="munily-title-preview"
  [ngClass]="containerClasses"
>
  <span class="munily-title-preview__text">{{ value }}</span>
  <common-icon-button
    *ngIf="showEditIcon"
    variant="plain"
    icon="edit"
    iconSet="material-icons-outlined"
    ariaLabel="Editar"
    class="munily-title-preview__edit-btn"
    (output)="onEdit()"
  ></common-icon-button>
</div>
